import { Typography } from '~/shared/components';
import { useTranslation } from '~/shared/utils/translation';
import { LoginDrawerMode, useLoginDrawer } from '../../hooks';
import styles from './LoginBanner.module.scss';

export const LoginBanner = () => {
    const { translate } = useTranslation();
    const { open } = useLoginDrawer();

    const text = translate('basket.rememberToLogIn');

    if (!text) return null;

    return (
        <Typography className={styles.loginBanner} variant="paragraph-S" weight="medium" as="p">
            {text}
            <button
                type="button"
                className={styles.loginButton}
                onClick={() => open(LoginDrawerMode.LOGIN)}
            >
                {translate('header.login')}
            </button>
        </Typography>
    );
};
